import Footer from "@/components/Footer";
import MarketingNav from "@/components/layout/MarketingNav";
import {
  HomeAI,
  HomeCommunity,
  HomeDownload,
  HomeEcosystem,
  HomeFinalCTA,
  HomeHero,
  HomeImpact,
  HomeJourney,
  HomeLearning,
  HomeOpportunities,
  HomePartners,
  HomeProblem,
  HomeSocialProof,
  HomeSolution,
  HomeTestimonials,
} from "@/components/home/HomeSections";

const Home = () => (
  <div className="min-h-screen bg-white flex flex-col overflow-visible">
    <MarketingNav />
    <main className="overflow-visible">
      <HomeHero />
      <HomeSocialProof />
      <HomeProblem />
      <HomeSolution />
      <HomeEcosystem />
      <HomeJourney />
      <HomeOpportunities />
      <HomeLearning />
      <HomeCommunity />
      <HomeAI />
      <HomeImpact />
      <HomePartners />
      <HomeTestimonials />
      <HomeDownload />
      <HomeFinalCTA />
    </main>
      <Footer />
    </div>
  );

export default Home;
